import {getWorkflowTemplateListInfoList} from "@/factory-api"
const state = {
  //公司列表数据
  companyList: [],
  //OA工作流模板下拉信息
  workflowTemplateList: '',
  //OA导航栏名字
  navBarName: 'OA',
  //审批内容
  approveForm: '',
}

const mutations = {
  //更新工作流模板的公共数据
  getWorkflowTemplateList (state, payload) {
    state.workflowTemplateList = payload
  },
  //更新公司列表数据
  updateCompanyList (state, companyList) {
    state.companyList = companyList
  },
  //更新每个路由下的导航栏的名字
  updateNavBarName (state, payload) {
    state.navBarName = payload
  },
  //更新审批内容
  updateApproveForm (state, payload) {
    state.approveForm = payload
  }
}

const actions = {
  //获取工作流模板的公共数据
  async getWorkflowTemplateList ({commit}, payload) {
    /*return new Promise( (resolve,reject) => {
       getWorkflowTemplateListInfoList({id: null})
        .then(async res => {
          console.log(res,"dddddddddddddddddd")
          await commit('getWorkflowTemplateList', res.data)
          resolve(res.data)
        })
        .catch(rej => {
          console.log(rej)
          reject(rej)
        })
    })*/
    await getWorkflowTemplateListInfoList(payload)
      .then(res => {
        commit('getWorkflowTemplateList', res.data)
      })
      .catch(rej => {
        console.log(rej)
      })
    /*commit('getWorkflowTemplateList', payload)*/
  },
  //获取公司列表数据
  updateCompanyList ({commit}, payload) {
    commit('updateCompanyList', payload)
  },
  //获取每个路由下的导航栏的名字
  updateNavBarName ({commit}, payload) {
    commit('updateNavBarName', payload)
  },
  //更新审批内容
  updateApproveForm ({commit}, payload) {
    commit('updateApproveForm', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/officeAutomation.js